import axios from "axios";

export default {
    startDemo: async () => {
        await axios.post(`/dispatcher/`, {}, {
            params: {
                action: 'start_demo'
            }
        })
    },
    endDemo: async() => {
        await axios.post(`/dispatcher/`, {}, {
            params: {
                action: 'delete_demo_account'
            }
        })
    }
}
